import React from 'react';
import DashboardListIcons from '../../Components/Dashboard/DashboarListIcon/DashboardListIcons';
import TopNav from '../../Components/Dashboard/Top-Nav/TopNav';
import UserListing from './UserListing';
import Layout from '../../Components/layout/Layout';

const User = () => {
  return (
    <Layout heading={'Users'}>
      <UserListing />
    </Layout>
  );
};

export default User;
